import React from 'react';


const CommonCodeReg = React.lazy(() => import('../Preferences/CommonCodeReg'));
const GroupAuthReg = React.lazy(() => import('../Preferences/GroupAuthReg'));
const PgmReg = React.lazy(() => import('../Preferences/PgmReg'));
const UpdateNoteManage = React.lazy(() => import('../Preferences/UpdateNoteManage'));
const AnnouncementManage = React.lazy(() => import('../Preferences/AnnouncementManage'));
const ProductRegistration = React.lazy(() => import('../ProductManage/ProductRegistration'));
const ProductIncoming = React.lazy(() => import('../ProductManage/ProductIncoming'));
const ProductOutgoing = React.lazy(() => import('../ProductManage/ProductOutgoing'));
const ProductStockStatus = React.lazy(() => import('../ProductManage/ProductStockStatus'));
const PartsRegistration = React.lazy(() => import('../PartsMange/PartsRegistration'));
const ProductPlanDaily = React.lazy(() => import('../ProductPlan/ProductPlanDaily'));
const ProductPlanWeekly = React.lazy(() => import('../ProductPlan/ProductPlanWeekly'));
const ProductPlanMonthly = React.lazy(() => import('../ProductPlan/ProductPlanMonthly'));
const ProductPlanAnnually = React.lazy(() => import('../ProductPlan/ProductPlanAnnually'));
const InventoryReport = React.lazy(() => import('../InventoryReport/InventoryReport'));
const InventoryDailyReport = React.lazy(() => import('../InventoryReport/InventoryDailyReport'));
const HomePage = React.lazy(() => import('../Home/HomePage'));


const pageComponentMap = {
    CommonCodeReg,
    GroupAuthReg,
    PgmReg,
    UpdateNoteManage,
    AnnouncementManage,
    ProductRegistration,
    ProductIncoming,
    ProductOutgoing,
    ProductStockStatus,
    PartsRegistration,
    ProductPlanDaily,
    ProductPlanWeekly,
    ProductPlanMonthly,
    ProductPlanAnnually,
    InventoryReport,
    HomePage,
    InventoryDailyReport
};

export default pageComponentMap;
